import React, { useMemo } from 'react';
import {
  BankDepositIcon,
  BillingCheckIcon,
  CardsItemIcon,
  PayPalIcon,
  VenmoIcon,
} from '@common-fe/common-fe';

import { PaymentMethodType } from '@/modules/user/user.types';

const DEFAULT_SIZE = '24px';

interface Props {
  paymentType?: PaymentMethodType;
  wrap?: (icon: React.ReactNode) => React.ReactNode;
  size?: string;
}

const PaymentTypeIcon: React.FC<Props> = ({ paymentType, wrap, size = DEFAULT_SIZE }) => {
  const icon = useMemo(() => {
    switch (paymentType) {
      case PaymentMethodType.DIRECT_DEPOSIT:
        return <BankDepositIcon size={size} color="iconAccent" />;

      case PaymentMethodType.DEBIT:
        return <CardsItemIcon size={size} color="iconAccent" />;

      case PaymentMethodType.PAYPAL:
        return <PayPalIcon width={size} height={size} />;

      case PaymentMethodType.VENMO:
        return <VenmoIcon width={size} height={size} />;

      case PaymentMethodType.CHECK:
        return <BillingCheckIcon size="20px" color="iconAccent" />;

      default:
        return null;
    }
  }, [paymentType, size]);

  return icon ? <>{wrap ? wrap(icon) : icon}</> : null;
};

export default PaymentTypeIcon;
